export default "__VITE_ASSET__aoBmpF4V__"